"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractListRanksResponseSchema = exports.RankResponseSchema = exports.WebContractGetMembershipResponseSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../../../shared");
const RankSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    createdAt: zod_1.default.coerce.date(),
    updatedAt: zod_1.default.coerce.date(),
    name: zod_1.default.string(),
    icon: zod_1.default.string(),
    impactRequired: zod_1.default.number(),
    discountRate: zod_1.default.number(),
});
const MembershipResponseSchema = zod_1.default.object({
    name: zod_1.default.string(),
    memberSince: zod_1.default.string().date(),
    rank: zod_1.default.object({
        id: zod_1.default.string(),
        name: zod_1.default.string(),
        icon: zod_1.default.string(),
        discountRate: zod_1.default.number(),
    }),
    nextRank: zod_1.default.object({
        id: zod_1.default.string(),
        name: zod_1.default.string(),
        icon: zod_1.default.string(),
        discountRate: zod_1.default.number(),
    }).nullable(),
    currentImpact: zod_1.default.number(),
    impactToNextRank: zod_1.default.number(),
});
exports.WebContractGetMembershipResponseSchema = zod_1.default.object({ membership: MembershipResponseSchema });
exports.RankResponseSchema = RankSchema.pick({
    id: true,
    name: true,
    icon: true,
    impactRequired: true,
    discountRate: true,
});
exports.WebContractListRanksResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ ranks: exports.RankResponseSchema.array() });
